export default "__VITE_ASSET__CZRhAz6q__"